import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
// import { PostHogProvider } from 'posthog-js/react'
import { env as environment } from "./environments";

const rootElement = environment["env"] === "CDN" ? document.getElementById('reactWidget') : document.getElementById('root');

// const options = {
//   api_host: "https://eu.i.posthog.com",
//   defaults: '2025-05-24',
//   loaded: (posthog) => {
//     // Check if the posthog object exists
//     if (posthog) {
//       // Set the environment as a global property on all events
//       posthog.register({
//         'environment': environment.env // Use environment.env to get the value
//       });
//     }
//   }
// }
const root = ReactDOM.createRoot(rootElement);
root.render(
  <React.StrictMode>
    {/* <PostHogProvider apiKey={"phc_za3owmqXM1LRJlfEbRXFuybiC7TIfN6vDzdgMtQdr0Y"} options={options}> */}
    <App />
    {/* </PostHogProvider> */}
  </React.StrictMode>
);

reportWebVitals();
